import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bdf9f29c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=bdf9f29c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf9f29c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wwwroot\\dealer-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdf9f29c')) {
      api.createRecord('bdf9f29c', component.options)
    } else {
      api.reload('bdf9f29c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bdf9f29c&scoped=true&", function () {
      api.rerender('bdf9f29c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/center/components/product/index.vue"
export default component.exports